import { render, staticRenderFns } from "./HeraFormSegmentControl.vue?vue&type=template&id=4d22604e&"
import script from "./HeraFormSegmentControl.vue?vue&type=script&lang=js&"
export * from "./HeraFormSegmentControl.vue?vue&type=script&lang=js&"
import style0 from "./HeraFormSegmentControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports